import config from '../config'

export default function createLocation(img, dimensions = [10, 10]) {
  const [xLength, yLength] = dimensions;
  const tiles = [];
  for (let i = 0; i < xLength; i++) {
    for (let j = 0; j < yLength; j++) {
      const tile = {
        coordinate: { x: j, y: i },
        position: getPositionInLocation(j, i),
        index: getIndexByTileCoordinate(j, i),
        asset: img,
      };
      tiles.push(tile);
    }
  }
  return tiles; 
}

const getIndexByTileCoordinate = (x, y) => {
  return x + config.LOCATION_DIMENSION[0] * y;
};

const getPositionInLocation = (Xi, Yi) => {
  const canvasWidth = config.LOCATION_DIMENSION[0] * config.TILE_WIDTH;
  const originX = canvasWidth / 2 - config.TILE_WIDTH / 2;
  const originY = 0;

  const x = (Xi * config.TILE_WIDTH) / 2 - (Yi * config.TILE_WIDTH) / 2 + originX;
  let y = (Yi * config.TILE_HEIGHT) / 2 + (Xi * config.TILE_HEIGHT) / 2 + originY;

  return { x, y };
};